export default "__VITE_PUBLIC_ASSET__0f83581b__"